import { useMutation, useQueryClient } from 'react-query';
import { FETCH_EPISODE_OVERVIEW } from 'client/hooks/episodes/useFetchEpisodeOverview';
import { AnchorAPI } from '../../modules/AnchorAPI';

function useSaveVideoToEpisode() {
  const queryClient = useQueryClient();
  const { mutate, status } = useMutation(
    ({
      webEpisodeId,
      videoUploadId,
    }: {
      webEpisodeId: string;
      videoUploadId: number;
    }) => {
      return AnchorAPI.saveVideoToEpisode({
        episodeId: webEpisodeId,
        videoUploadId,
      });
    },
    {
      onSuccess: (_data, variables) => {
        const { webEpisodeId } = variables;
        return queryClient.invalidateQueries([
          FETCH_EPISODE_OVERVIEW,
          webEpisodeId,
        ]);
      },
    }
  );

  return { saveVideoToEpisode: mutate, status };
}

export { useSaveVideoToEpisode };
